export const slugify = (text) =>
  String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const collectHeadings = (body1) => {
  if (!Array.isArray(body1)) return [];
  const headings = [];
  body1.forEach((slice) => {
    if (slice?.slice_type !== 'rich_text') return;
    const nodes = slice?.primary?.text?.richText;
    if (!Array.isArray(nodes)) return;
    nodes.forEach((node) => {
      if (node?.type === 'heading2' && node.text) {
        headings.push({ id: slugify(node.text), text: node.text });
      }
    });
  });
  return headings;
};
